if (!customElements.get("demo-header")) {
  class DemoHeader extends HTMLElement {
    /**
     * Constructor
     */
    constructor() {
      super();
      this.toggle_menu_btn_elem = this.querySelector(".js-toggle-menu");
      this.header_elem = this.querySelector(".js-header");
      this.bindEventHandlers();      
      this.sticky()
      this.navHighlighter();
    }

    /**
     * bind event handler to web component elements
     */
    bindEventHandlers() {
      this.toggle_menu_btn_elem.addEventListener(
        "click",
        function (event) {
          this.toggleMenu();
        }.bind(this)
      );
      window.addEventListener('scroll', this.sticky.bind(this));      
    }

    toggleMenu() {
      this.header_elem.classList.toggle("section-header--mobile-menu-open");
      document.body.classList.toggle('ovh')
    };
    navHighlighter(){
      const sections = document.querySelectorAll('[data-pf-type="Section"][id]');
      window.addEventListener("scroll", function(){
        let scrollY = window.pageYOffset;
        sections.forEach(current => {
          const sectionHeight = current.offsetHeight;
          const sectionTop = (current.getBoundingClientRect().top + window.pageYOffset) - 150;
          const sectionId = current.getAttribute("id");
          if (
            scrollY > sectionTop &&
            scrollY <= sectionTop + sectionHeight
          ){
            document.querySelector(".main-navigation .nav__link[href*=" + sectionId + "]").classList.add("active");
          } else {
            document.querySelector(".main-navigation .nav__link[href*=" + sectionId + "]").classList.remove("active");
          }
        });
    })}
	sticky() {
		if (window.pageYOffset > 0) {
			this.header_elem.classList.add('header-sticky');
        } else {
            this.header_elem.classList.remove('header-sticky');
        };
    };
  }
  customElements.define("demo-header", DemoHeader);
}

